import { loaderStyles } from './ctaLoadingAnimation'
import { keenStyles } from './keenStyles'

export const lpGlobalCSS = () => `
  ${loaderStyles}
  ${keenStyles}
`
